import React, { ReactElement } from 'react';

export const Chips: React.FC<{}> = ({ children }): ReactElement => {
  return <div className="field is-grouped is-grouped-multiline">{children}</div>;
};
